import Skeleton from "../../common/Skeleton";

const InsiderDetailSkeleton = () => {
  return (
    <>
      {[...Array(10)].map((_, index) => (
        <tr
          key={index}
          className="border-b border-[#d0d4e4] dark:border-[#394564]"
        >
          {/* Stock & Person (25%) */}
          <td className="py-2 px-2">
            <div className="flex items-center">
              <Skeleton className="w-4 h-4 mr-2 rounded" />
              <div>
                <Skeleton className="w-32 h-4 rounded mb-1" />
                <Skeleton className="w-16 h-3 rounded" />
              </div>
            </div>
          </td>

          {/* Category (15%) */}
          <td className="py-2 px-2">
            <Skeleton className="w-20 h-5 rounded-full" />
          </td>

          {/* Transaction (15%) */}
          <td className="py-2 px-2">
            <div className="flex items-center gap-2">
              <Skeleton className="w-16 h-5 rounded" />
              <Skeleton className="w-20 h-3 rounded" />
            </div>
          </td>

          {/* Amount (15%) */}
          <td className="py-2 px-2">
            <Skeleton className="w-24 h-4 rounded mb-1" />
            <Skeleton className="w-32 h-3 rounded" />
          </td>

          {/* Holding Change (15%) */}
          <td className="py-2 px-2">
            <Skeleton className="w-24 h-3 rounded mb-1" />
            <Skeleton className="w-16 h-5 rounded" />
          </td>

          {/* Broadcast Date (10%) */}
          <td className="py-2 px-2">
            <Skeleton className="w-20 h-4 rounded" />
          </td>
        </tr>
      ))}
    </>
  );
};

export default InsiderDetailSkeleton;
